import { logger } from "@/logging";
import { HydraChain } from "../HydraEndpoint";

export const buildHydraFn = (hydra: any, chain: HydraChain) => {
  let fn: any = null;

  for (const meta of chain) {
    if (!meta) continue;

    if (meta.newSource) {
      const src = hydra.createSource();
      if (meta.newSource.type === 'webcam') {
        src.initCam();
      } else if (meta.newSource.type === 'file') {
        src.init({ src: meta.newSource.data });
      } else if (meta.newSource.type === 'canvas') {
        src.init({ src: meta.newSource.data, dynamic: true });
      } else {
        throw new Error('could not initialised new source - unknown type:' + meta.newSource.type)
      }

      fn = hydra.synth.src(src);
    }
    else if (meta.source) {
      // Source function: osc(), noise(), shape(), etc.
      const sourceFn = hydra.synth[meta.name];
      if (!sourceFn) {
        logger.error(`Unknown Hydra source: ${meta.name}`);
        return null;
      }
      fn = sourceFn.call(hydra.synth, ...(meta.args || []));
    } else if (meta.effect || meta.composite) {
      // Effect or composite: needs existing chain
      if (!fn) {
        logger.error('Effect/composite without source chain');
        return null;
      }

      const effectFn = fn[meta.name!];
      if (!effectFn) {
        logger.error(`Unknown Hydra function: ${meta.name}`);
        return null;
      }

      // For composites, first arg is secondary chain - recurse to build it
      const args = (meta.args || []).map((arg, idx) => {
        if (meta.composite && idx === 0 && Array.isArray(arg)) {
          return buildHydraFn(hydra, arg);
        }
        return arg;
      });

      fn = effectFn.call(fn, ...args);
    }
  }

  return fn;
}